export default __webpack_public_path__ + "static/media/check.9a4fcb04.svg";